import request from '@/utils/request'
import { toCmsContent, mapPageResult, mapSingleResult } from './helpers'

export function getNewsList (params) {
  return request.get('/api/cms/list', {
    params: { ...params, type: 'LAB_NEWS' }
  }).then(mapPageResult)
}

export function getNewsDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export const addNews = (data) => {
  return request.post('/api/cms', toCmsContent(data, 'LAB_NEWS'))
}

export const updateNews = (data) => {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'LAB_NEWS'))
}

export const deleteNews = (id) => {
  return request.delete(`/api/cms/${id}`)
}
